const defaultFabricAttributesConfig = {
    originX: 'center',
    originY: 'center',
    type: 'table',
    zoomX: 1,
    zoomY: 1
};

module.exports = defaultFabricAttributesConfig;
